import { __spreadArray } from 'tslib';
import React__default from 'react';
import { useTheme, TableCell, TableRow, Skeleton } from '@mui/material';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../../../providers/locale/hooks.js';
import StyledKTableContainer, { classes } from './index.styled.js';
import { renderTitleCell, renderLastRunCell, renderActionsCell } from './utils.js';

var KTableContainer = function KTableContainer(_a) {
    var totalCount = _a.totalCount, rows = _a.rows, loading = _a.loading, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "KTableContainer" : _b, onRunScript = _a.onRunScript, sx = _a.sx, KIcon = _a.KIcon;
    var dataLocale = useLocale().dataLocale;
    var t = useTranslation("refront-components").t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var theme = useTheme();
    var columnsData = [
        {
            columnName: t("components.kf-script-manager.table.header.cell.title"),
            columnWidth: "100%",
            className: classes.ellipsisCell,
            columnRender: function (row) { return renderTitleCell(row); }
        },
        {
            columnName: t("components.kf-script-manager.table.header.cell.last-run"),
            columnWidth: "230px",
            columnRender: function (row) { return renderLastRunCell(row); }
        },
        {
            columnName: t("components.kf-script-manager.table.header.cell.actions"),
            columnWidth: "130px",
            className: classes.ellipsisCell,
            headerClassName: classes.actionCell,
            columnRender: function (row, t) { return renderActionsCell(row, t, onRunScript, KIcon) || null; }
        },
    ];
    return (React__default.createElement(StyledKTableContainer, { className: clsx("KTableContainer", className), "data-testid": testId, columnsComponent: columnsData.map(function (columnData) { return (React__default.createElement(TableCell, { key: columnData.columnName, className: columnData.headerClassName, width: columnData.columnWidth }, columnData.columnName)); }), loading: loading, loadingComponent: __spreadArray([], Array(1), true).map(function (_value, index) { return (React__default.createElement(TableRow, { key: index },
            React__default.createElement(TableCell, { colSpan: columnsData.length, align: "center" },
                React__default.createElement(Skeleton, { animation: "wave" })))); }), totalCount: totalCount, noResultComponent: React__default.createElement(TableRow, null,
            React__default.createElement(TableCell, { colSpan: columnsData.length, align: "center" }, t("components.kf-script-manager.table.body.cell.no-result"))), sx: sx }, rows &&
        rows.map(function (row) { return (React__default.createElement(TableRow, { key: row.id }, columnsData.map(function (columnData) { return (React__default.createElement(TableCell, { key: columnData.columnName, className: columnData.className }, columnData.columnRender(row, t, theme, dataLocale, enqueueSnackbar))); }))); })));
};

export { KTableContainer as default };
//# sourceMappingURL=index.js.map
